export default {
    menus: {
        '/': '首页',
        m: '首页',
        homePage: '首页',
        '/homePage': '总览页',
        userInfo: '个人信息',
        '/userInfo': '个人信息',
        userProducts: '我的套餐',
        userOrder: '我的订单',
        userRetail: '代理分销',
        userPassword: '修改密码',
        Vips: 'VIP升级',
        Pedigree: '谱系',
        PedigreeDetail: '谱系编辑',
        Spectrums: '谱文',
        Books: '谱书',
        BookDetails: '编辑谱书',
        BookConfigs: '版式设置',
        PrintPreview: '谱书预览',
        Prints: '谱书预览'
    },
    login: {
        title: '用户登录',
        btnTitle: '登录',
        btnResetPwd: '重置密码',
        btnRegister: '注册'
    },
    dialog: {
        deleteTitle: '确定要删除用户'
    },
    table: {
        name: '谱系名称',
        clanQuantity: '谱系人数',
        createTime: '创建时间',
        updateTime: '最近更新',
        action: '操作',
        logtitle: '日志标题',
        logtype: '类型',
        clanname: '族谱',
        clanmenber: '族员',
        devicetype: '平台',
        device: '设备',
        content: '日志内容',
        ipaddress: '操作IP',
        book: '体例',
        priview: '预览',
        standard: '标清',
        highquality: '高清',
        print: '印谱',
        wxshow: '小程序端显示'
    },
    message: {
        updeteSuccess: '更新成功',
        removeSuccess: '删除成功'
    },
    driver: {
        doneBtnText: '完成',
        closeBtnText: '关闭',
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        guideBtn: '引导按钮',
        hamburgerBtn: '汉堡按钮',
        fullScreen: '全屏按钮'
    }
}
